module.exports = __webpack_public_path__ + "img/eye.309cbc39.svg";